export class DataUtil {
    static toFrontEndRow(row) {
        return {
            appointmentId: row.id,
            patientId: row.id_patient,
            organizationId: row.id_organization,
            appointmentTime: row.appointment_date,
            appointmentType: row.ehr_appointment_type_name,
            organizationName: row.organization_name,
            firstName: row.first_name,
            lastName: row.last_name,
            mrn: row.mrn,
            surveyId: row.id_patient_survey_link,
            providerId: row.id_provider,
            providerFirstName: row.provider_first_name,
            providerLastName: row.provider_last_name,
            userAgent: row.user_agent
        };
    }
}
